
(function() {

var ajax_optionDiv = false;
var ajax_optionDiv_iframe = false;
var ajax_list_objects = new Array();
var ajax_list_cachedLists = new Array();
var ajax_list_activeInput = false;
var ajax_list_activeItem;
var ajax_list_optionDivFirstItem = false;
var ajax_list_currentLetters = new Array();
var ajax_list_externalFile = 'ajax-list-countries.php';	// Path to external file
var ajaxBox_offsetX = 0;
var ajaxBox_offsetY = 0;
var minimumLettersBeforeLookup = 1;	// Number of letters entered before a lookup is performed.
var MatchRequestPending = false;	// true if there is an AJAX request pending

	window.AjaxRequestMatches = function(TableName, ColumnName, InputBox, e, forceMatch)
	{
		// ignore some keys
		if(	(e.keyCode==13) || 	// enter
			(e.keyCode==9) ||	// tab
			(e.keyCode==38) || 	// up arrow
			(e.keyCode==40) ||	// down arrow
			(e.keyCode==27)) 	// escape
		{
			return;
		}

		if (InputBox.value == "")
		{
			ajax_options_hide();
			CheckModified(InputBox);
			return;
		}

		// perform  searching ''onkeyup'' only on fields that have lkup dropdown menu enabled
		if (undefined === forceMatch)
		{
			return;	
		}
		if (!forceMatch)
		{
			return;	
		}

		if (false === MatchRequestPending)
		{
			MatchRequestPending = true;

			$.ajax(
			{
				type : "get",
				url : "/GetSearchMatches.php",
				data : 'TableName=' + TableName + '&ColumnName=' + ColumnName + '&Value=' + escape (InputBox.value) + '&AJAX=1',
			})
			.done (function(Response, testStatus, jqXHR)
			{
				AjaxShowMatches(Response, InputBox, forceMatch);
			})
			.fail (function(jqXHR, textStatus, errorThrown)
			{
				DisplayAjaxError(errorThrown, textStatus, '');
			})
			.always (function(jqXHR, textStatus, errorThrown)
			{
				MatchRequestPending = false;
			});
		}
	}

	function AjaxShowMatches(Response, InputBox, forceMatch)
	{
		if (Response == "")
		{
			ajax_options_hide();
			return;	
		}

		var Data = new Array();
		var numMatches, Status;

		var ResponseText = ParseAjaxResponse(Response, 'html');
		if (ResponseText)
		{
			// Extract status & create a list from the response
			// Before spliting, remove line breaks in the string
			Data = ResponseText.replace(/(\r\n|\n|\r)/gm, "").split('|');
			Status = Data[0];
			numMatches = Data.length - 1;
		}
		else
		{
			Status = 'FAIL';
			numMatches = 0;
		}

		if (numMatches == 0)
		{
			ajax_options_hide();
			// when  returned status is 'FAIL'
			/// This widget requires a match, so need to reject the last key
			if (Status == 'FAIL')
			{
				var MaxAllowed = InputBox.value.length - 1;
				InputBox.value = InputBox.value.substring(0, MaxAllowed);
			}
			return;			
		}

		var AjaxMatches = Data.splice(1, numMatches);

		// create the option DIV
		if (!ajax_optionDiv)
		{
			ajax_optionDiv = document.createElement('DIV');
			ajax_optionDiv.id = 'ajax_listOfOptions';	
			document.body.appendChild(ajax_optionDiv);

			$('li.ui-state-default').mousedown(function()
			{
				ajax_options_hide();
			});

			var allInputs = document.getElementsByTagName('INPUT');
			for(var no=0;no<allInputs.length;no++)
			{
				if(!allInputs[no].onkeyup)
				{
					allInputs[no].onfocus = ajax_options_hide;
				}
			}
			var allSelects = document.getElementsByTagName('SELECT');
			for(var no=0;no<allSelects.length;no++)
			{
				allSelects[no].onfocus = ajax_options_hide;
			}

			var oldonkeydown=document.body.onkeydown;
			if(typeof oldonkeydown!='function')
			{
				document.body.onkeydown=ajax_option_keyNavigation;
			}
			else
			{
				document.body.onkeydown=function()
				{
					oldonkeydown(); ajax_option_keyNavigation() ;
				};
			}
			var oldonresize=document.body.onresize;
			if(typeof oldonresize!='function')
			{
				document.body.onresize=function()
				{
					ajax_option_resize(InputBox);
				};
			}
			else
			{
				document.body.onresize=function()
				{
					oldonresize(); ajax_option_resize(InputBox) ;
				};
			}					
		}

		ajax_optionDiv.innerHTML = '';
		ajax_list_activeItem = false;

		ajax_list_optionDivFirstItem = false;
		var optionsAdded = false;
		for (var no = 0; no < AjaxMatches.length; no++)
		{
			optionsAdded = true;
			var div = document.createElement('DIV');
			var items = AjaxMatches[no].split(/###/gi);

			if((AjaxMatches.length==1) && (ajax_list_activeInput.value == items[0]))
			{
				ajax_options_hide();
				return;						
			}


			div.innerHTML = items[items.length-1];
			div.id = items[0];
			div.className='optionDiv';
			div.onmouseover = function()
			{
			 	ajax_options_rollOverActiveItem(this,false) ;
			};

			div.onclick = ajax_option_setValue;
			if(!ajax_list_optionDivFirstItem)
			{
				ajax_list_optionDivFirstItem = div;
			}

			ajax_optionDiv.appendChild(div);
		}	
	
		if(optionsAdded)
		{
			ajax_optionDiv.style.display='block';
			if(ajax_optionDiv_iframe)
			{
				ajax_optionDiv_iframe.style.display='';
			}
		}			
	
		if(InputBox.value.length<minimumLettersBeforeLookup)
		{
			ajax_options_hide();
			return;
		}

		ajax_optionDiv.style.top = (ajax_getTopPos(InputBox) + InputBox.offsetHeight + ajaxBox_offsetY) + 'px';
		ajax_optionDiv.style.left = (ajax_getLeftPos(InputBox) + ajaxBox_offsetX) + 'px';
		if(ajax_optionDiv_iframe)
		{
			ajax_optionDiv_iframe.style.left = ajax_optionDiv.style.left;
			ajax_optionDiv_iframe.style.top = ajax_optionDiv.style.top;			
		}

		ajax_list_activeInput = InputBox;
		ajax_optionDiv.onselectstart = ajax_list_cancelEvent;

		ajax_option_resize(InputBox);
	}

	function ajax_getTopPos(inputObj)
	{
		var returnValue = inputObj.offsetTop;
		// IE8 needs the try/catch or errors with 'Unspecified Error' when inputObj.offsetParent is null
		try
		{
			while ((inputObj = inputObj.offsetParent) != null)
			{
				returnValue += inputObj.offsetTop;
			}
		}
		catch(e)
		{
		}

		return returnValue;
	}

	function ajax_list_cancelEvent()
	{
		return false;
	}

	function ajax_getLeftPos(inputObj) {
		var returnValue = 0;
		var element = inputObj;
		// IE8 needs the try/catch or errors with 'Unspecified Error' when inputObj.offsetLeft is null
		try
		{
			while (true) {
				returnValue += element.offsetLeft;
				if (element.offsetParent == null) {
					break;
				}
				element = element.offsetParent;
			}

			// Starting in 12.3 the lists can be panned via arrows.  Get that offset.
			var $listWrapper = getDivToMove($('#' + inputObj.id), 'up');
			if ($listWrapper) {
				var listWrapper = $listWrapper.get(0);
				returnValue -= listWrapper.scrollLeft;
			}
		}
		catch(e)
		{
		}

		return returnValue;
	}

	function ajax_option_setValue(e,inputObj)
	{
		if (!inputObj)
		{
			inputObj=this;
		}
		var tmpValue = inputObj.textContent || inputObj.innerText;
		if (!tmpValue)
		{
			tmpValue = inputObj.innerHTML;
		}
		ajax_list_activeInput.value = tmpValue;
	
		if (document.getElementById(ajax_list_activeInput.name + '_hidden'))
		{
			document.getElementById(ajax_list_activeInput.name + '_hidden').value = inputObj.id;
		}
		ajax_do_onchange ();
		ajax_options_hide();
	}

	window.ajax_options_hide = function()
	{
		if (!ajax_optionDiv)
		{
			return;
		}

		ajax_optionDiv.style.display='none';	
		if (ajax_optionDiv_iframe)
		{
			ajax_optionDiv_iframe.style.display='none';
		}

		/***************************************************************************
	 	* * 10.3 if (ajax_list_activeInput) { if
	 	* (ajax_list_activeInput.getAttribute('modifyCheck') != null)
	 	* CheckModified(ajax_list_activeInput); }
	 	**************************************************************************/
	}

	window.ajax_options_rollOverActiveItem = function(item,fromKeyBoard)
	{
		if(ajax_list_activeItem)
		{
			ajax_list_activeItem.className='optionDiv';
		}
		item.className='optionDivSelected';
		ajax_list_activeItem = item;

		if(fromKeyBoard){
			if(ajax_list_activeItem.offsetTop>ajax_optionDiv.offsetHeight){
				ajax_optionDiv.scrollTop = ajax_list_activeItem.offsetTop - ajax_optionDiv.offsetHeight + ajax_list_activeItem.offsetHeight + 2 ;
			}
			if(ajax_list_activeItem.offsetTop<ajax_optionDiv.scrollTop)
			{
				ajax_optionDiv.scrollTop = 0;	
			}
		}
	}

	function ajax_option_list_showContent(ajaxIndex,inputObj,paramToExternalFile)
	{
		var letters = inputObj.value;
		var content = ajax_list_objects[ajaxIndex].response;
		var elements = content.split('|');
		ajax_list_cachedLists[paramToExternalFile][letters.toLowerCase()] = elements;
		ajax_option_list_buildList(letters,paramToExternalFile);
	}

	function ajax_option_resize(inputObj)
	{
		ajax_optionDiv.style.top = (ajax_getTopPos(inputObj) + inputObj.offsetHeight + ajaxBox_offsetY) + 'px';
		ajax_optionDiv.style.left = (ajax_getLeftPos(inputObj) + ajaxBox_offsetX) + 'px';
		ajax_optionDiv.style.minWidth = inputObj.offsetWidth;
		ajax_optionDiv.style.width = 'auto';

		var height = 0;
		for (var i=0; i<ajax_optionDiv.childNodes.length; i++)
		{
			height += ajax_optionDiv.childNodes[i].offsetHeight + 1;
		}
		height += 3;
		ajax_optionDiv.style.height = height + 'px';
	
		if(ajax_optionDiv_iframe)
		{
			ajax_optionDiv_iframe.style.left = ajax_optionDiv.style.left;
			ajax_optionDiv_iframe.style.top = ajax_optionDiv.style.top;			
		}		
	}

	function ajax_option_keyNavigation(e)
	{
		if(document.all)
		{
			e = event;
		}

		if(!ajax_optionDiv)
		{
			return;
		}
		if(ajax_optionDiv.style.display=='none')
		{
			return;
		}

		if(e.keyCode==38)
		{	// Up arrow
			if(!ajax_list_activeItem)
			{
				return;
			}
			if(ajax_list_activeItem && !ajax_list_activeItem.previousSibling)
			{
				return;
			}
			ajax_options_rollOverActiveItem(ajax_list_activeItem.previousSibling,true);
		}

		if(e.keyCode==40)
		{	// Down arrow
			if(!ajax_list_activeItem)
			{
				ajax_options_rollOverActiveItem(ajax_list_optionDivFirstItem,true);
			}
			else
			{
				if(!ajax_list_activeItem.nextSibling)
				{
					return;
				}
				ajax_options_rollOverActiveItem(ajax_list_activeItem.nextSibling,true);
			}
		}

		if((e.keyCode==13) || (e.keyCode==9))
		{	// Enter key or tab key
			if(ajax_list_activeItem && (ajax_list_activeItem.className=='optionDivSelected'))
			{
				ajax_option_setValue(false,ajax_list_activeItem);
			}
			ajax_do_onchange ();
			ajax_options_hide ();
			if(e.keyCode==13)
			{
				return false;
			}
			else
			{
				return true;
			}
		}
		if(e.keyCode==27)
		{	// Escape key
			ajax_options_hide();			
		}
	}

	function ajax_do_onchange()
	{
		var func = ajax_list_activeInput.getAttribute('onchangeAJAX');
		if (isset(func))
		{
			eval(func);
		}
	}

/** unused
function DisplayError(e)
{
	if (typeof(e) == 'object')
	{
		Message = e.message;
	}
	else if (typeof(e) == 'string')
	{
		Message = e;
	}
	else
	{
		Message = 'Unknown Error';
	}
	alert(Message);
}
**/

} ());



